import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "CareFirst BlueCross BlueShield",
  shortName: "CareFirst",
  slug: "carefirst-insurance",
  seoTitle:
    "CareFirst BlueCross BlueShield TMS & SPRAVATO® Coverage | Neuro Wellness TMS",
  seoDescription:
    "Learn how CareFirst BlueCross BlueShield policies cover TMS Therapy, SPRAVATO® esketamine, and advanced depression care at Neuro Wellness TMS in Coral Springs, FL.",
  seoKeywords:
    "CareFirst TMS coverage, CareFirst BlueCross BlueShield SPRAVATO authorization, CareFirst mental health benefits Coral Springs FL, CareFirst depression treatment Florida",
};

export const CareFirstInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default CareFirstInsurance;
